export default {
    missingEmail:
        "Logowanie nieudane. {0} nie udostępnił adresu e-mail. Użyj innej metody logowania.",
};
